<app-loader [fullPage]="true"
            [loaderId]="loaderId">
  <ng-container *ngIf="initialized && !block"> 
    <router-outlet></router-outlet>
  </ng-container>
  <app-work-in-progress *ngIf="block"
                        [subTitle]="workInProgressTitle">
  </app-work-in-progress>
</app-loader>